import React from "react";
import css from "./section.module.css";
import resources from "./../../../../resources/index";
import { FaFingerprint,FaBezierCurve  ,FaCheck } from "react-icons/fa";


const Section3 = () => {
  return (
    <div className={css.section3}>

      <div className={css.left}>
        <div className={css.text}>
        <h5>Features</h5>
        <h2>Powerful Solutions for Your Business Needs</h2>
        <p>
          Quickly incubate functional channels with multidisciplinary
          architectures authoritatively fabricate.
        </p>
        </div>

        <div className={css.feature_div}>
          <div style={{ backgroundColor: "blue" }} className={css.feature_icon_div}>
            <FaBezierCurve className={css.icon} />
          </div>
          <div className={css.feature_text}>
            <h3>Pixel Perfect Design</h3>
            <p>
            Progressively foster enterprise-wide systems whereas equity invested web-readiness harness installed.
            </p>
          </div>
        </div>

        <div className={css.feature_div}>
          <div style={{ backgroundColor: "red" }} className={css.feature_icon_div}>
            <FaFingerprint className={css.icon} />
          </div>
          <div className={css.feature_text}>
            <h3>Unique & Minimal Design</h3>
            <p>
            Dramatically administrate progressive metrics without error-free globally simplify standardized.
            </p>
          </div>
        </div>
      </div>

      <div className={css.right}>
        <img src={resources.images.about_sec3} alt="About Section 3" />
        <ul className={css.list}>
          <li> <FaCheck className={css.check} />Create a Free Account</li>
          <li> <FaCheck className={css.check} />Install Our Tracking Pixel</li>
          <li> <FaCheck className={css.check} />Start Tracking your Website</li>
        </ul>
      </div>
      
    </div>
  );
};

export default Section3;
